(() => {
  const isArabic = () => /^ar(?:-|$)/i.test(document.documentElement.lang || '');

  const formatAmount = (cents) => new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(Number(cents) / 100);

  const set = (element, cents, fallback = '') => {
    if (!element) return;
    if (cents == null || String(cents).trim() === '') {
      element.textContent = fallback;
      return;
    }
    const value = Number(cents);
    if (!isArabic() || !Number.isFinite(value)) {
      element.textContent = fallback;
      return;
    }

    const amount = document.createElement('bdi');
    amount.className = 'pp-price__amount';
    amount.dir = 'ltr';
    amount.textContent = formatAmount(value);

    const currency = document.createElement('span');
    currency.className = 'pp-price__currency';
    currency.textContent = document.documentElement.dataset.ppCurrencyLabel || '';

    element.dir = 'rtl';
    element.replaceChildren(amount, ' ', currency);
  };

  window.PerfumePalacePrice = { set };
})();
